import { timelineEvents } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
            <div>
              <span className="text-xs text-primary-600">按时间倒序 · 持续更新</span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                后续瓜 · 一条时间线看完
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              从首段录音流出到各方回应，关键节点按时间排列，新进展会自动补到最上方。
            </p>
          </div>
        </Reveal>

        <ol className="relative ml-2 border-l border-background-200">
          {timelineEvents.map((event, index) => (
            <li key={event.id} className="relative pb-8 pl-6 last:pb-0 md:pl-8">
              <span
                className={`absolute -left-[7px] top-1 h-3.5 w-3.5 rounded-full border-2 ${
                  index === 0
                    ? "border-accent-500 bg-accent-500"
                    : "border-background-300 bg-background-50"
                }`}
              />
              <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-heading text-sm font-bold text-foreground-950">
                    {event.date}
                  </span>
                  <span className="text-xs text-foreground-500">{event.time}</span>
                  <span
                    className={`rounded-full px-2 py-0.5 text-[11px] ${
                      event.official
                        ? "bg-secondary-100 text-secondary-900"
                        : index === 0
                          ? "bg-accent-100 text-accent-900"
                          : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    {event.tag}
                  </span>
                  {index === 0 && (
                    <span className="flex items-center gap-1 text-[11px] text-primary-600">
                      <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
                      刚刚更新
                    </span>
                  )}
                </div>
                <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                  {event.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {event.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}